import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_PAYMENTS_CREATE, KEY_POST_PAYMENTS_CREATE } from '../constants';
import { MOCK_RESPONSE_POST_PAYMENTS_CREATE } from '../mocks';
import { CreatePaymentsParams } from '../types';

export type CallParamsPostPaymentsCreate = CreatePaymentsParams & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostPaymentsCreate = {
  url: string;
};

type CallErrorPostPaymentsCreate = GenericApiError;

type CallSelectorsPostPaymentsCreate = {
  checkoutUrl: string;
};

export const postPaymentsCreateCall = createGeneralCall<
  CallParamsPostPaymentsCreate,
  CallResponsePostPaymentsCreate,
  CallErrorPostPaymentsCreate,
  CallSelectorsPostPaymentsCreate
>({
  id: KEY_POST_PAYMENTS_CREATE,
  url: API_PAYMENTS_CREATE,
  paramsSelector:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return {
        organizationId: org,
        ...payload,
      };
    },
  selectors: {
    checkoutUrl: ({ selectors }) => createSelector(selectors.response, res => res?.url),
  },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_PAYMENTS_CREATE : undefined,
});
